


import { HomeOverview } from "../components/HomeOverview"
import { SolarSystem } from "../components/SolarSystem"
import { HomepageSection } from "../components/HomepageSection"
import { useState } from "react"
import { Link } from "react-router-dom"


function Homepage() {

    const [hoveredPlanet, setHovered] = useState("sun-center")

    function handleHover(e) {
        const classList = Array.from(e.currentTarget.classList)
        const hoveredPlanetClass = classList.find(e => e !== "planet-art" && e !== "sun-art")
        setHovered(hoveredPlanetClass)
    }

    
    const overviewTexts = [
        <p className="overview-text">
            I started studying <span className="emp-text">Computer Science</span> back in Fall 2020 and I have graduated in 2023. I am currently starting to learn TypeScript as of now.
        </p>,
        <p className="overview-text">
            I have an Intermediate level of <span className="emp-text">JavaScript</span> and a Amateur level of React and Java and C#.
        </p>,
        <p className="overview-text">
            Here are some of my projects (asteroids) I have captured (done).
        </p>,
        <p className="overview-text">
            What I also do alongside my career.
        </p>
    ]

    return (
        <>
            <main className="main-homepage">
                <div className="solarsystem-info-container">
                    <SolarSystem handleHover={(e) => handleHover(e)}></SolarSystem>
                    { hoveredPlanet === "sun-center" && <HomeOverview></HomeOverview>}
                    { hoveredPlanet === "planet-i" && <HomepageSection overviewText={overviewTexts[0]} name="about" sectionHeading="Planet I: About me"></HomepageSection>}
                    { hoveredPlanet === "planet-ii" && <HomepageSection overviewText={overviewTexts[1]} name="projects" sectionHeading="Planet II: My projects"></HomepageSection>}
                    { hoveredPlanet === "planet-iii" && <HomepageSection overviewText={overviewTexts[2]} name="skills" sectionHeading="Planet III: My skills"></HomepageSection>}
                    { hoveredPlanet === "planet-iv" && <HomepageSection overviewText={overviewTexts[3]} name="hobbies" sectionHeading="Planet IV: My hobbies"></HomepageSection>}
                </div>
                <div className="mobile-homepage-list">
                    <HomeOverview></HomeOverview>
                    <HomepageSection overviewText={overviewTexts[0]} name="about" sectionHeading="Planet I: About me"/>
                    <Link to="/about">
                        <div className="planet-art planet-i">
                            <div className="planet-art__clouds-container">
                                <div className="planet-i-cloud-1 planet-i-cloud"></div>
                                <div className="planet-i-cloud-2 planet-i-cloud"></div>
                                <div className="planet-i-cloud-3 planet-i-cloud"></div>
                            </div>
                        </div>
                    </Link>      
                    <HomepageSection overviewText={overviewTexts[1]} name="projects" sectionHeading="Planet II: My projects"></HomepageSection>
                    <Link to="/projects">
                        <div className="planet-art planet-ii">
                            <div className="planet-art__clouds-container">
                                <div className="planet-ii-cloud-1 planet-ii-cloud"></div>
                                <div className="planet-ii-cloud-2 planet-ii-cloud"></div>
                                <div className="planet-ii-cloud-3 planet-ii-cloud"></div>
                            </div>
                        </div>
                    </Link>
                    <HomepageSection overviewText={overviewTexts[2]} name="skills" sectionHeading="Planet III: My skills"></HomepageSection>
                    <Link to="/skills">
                        <div className="planet-art planet-iii">
                            <div className="planet-art__clouds-container">
                                <div className="planet-iii-cloud-1 planet-iii-cloud"></div>
                                <div className="planet-iii-cloud-2 planet-iii-cloud"></div>
                                <div className="planet-iii-cloud-3 planet-iii-cloud"></div>
                            </div>
                        </div>
                    </Link>
                    <HomepageSection overviewText={overviewTexts[3]} name="hobbies" sectionHeading="Planet IV: My hobbies"></HomepageSection>
                    <Link to="/leisure">
                        <div className="planet-art planet-iv">
                            <div className="planet-art__clouds-container">
                                <div className="planet-iv-cloud-1 planet-iv-cloud"></div>
                                <div className="planet-iv-cloud-2 planet-iv-cloud"></div>
                                <div className="planet-iv-cloud-3 planet-iv-cloud"></div>
                            </div>
                        </div>
                    </Link>
                    
                </div>
                
            </main>
        </>
        
    )
}

export default Homepage